import styled from "styled-components";

export const ModalsCloseButtonStyled = styled.div`
  position: absolute;
  top: 8px;
  right: 8px;
  cursor: pointer;
  font-size: 12px;
  height: 30px;
  width: 30px;
  display: flex;
  justify-content: center;
  align-items: center;
  
  svg {
    fill: #8B8EAE;
  }

  &:hover {
    svg {
      fill: var(--color-white);
    }
  }
`;
